module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_0.69a91f9d.png";